import React from "react";
import "./StaticPage.css";

export default function ReturnPolicy() {
  return (
    <div className="static-page">
      <div className="static-container">
        <span className="section-label">Policies</span>
        <h1>Return &amp; Refund Policy</h1>
        <p className="static-intro">
          We stand behind every jar we send. If something's not right, we'll make it right.
        </p>

        <section>
          <h2>1. Eligibility Window</h2>
          <p>
            You may raise a return or refund request within <strong>2 days</strong> of
            receiving your order. Requests raised after this window will not be accepted.
          </p>
        </section>

        <section>
          <h2>2. What We Accept</h2>
          <p>We accept returns and issue refunds in the following cases:</p>
          <ul>
            <li><strong>Unopened products</strong> — seal intact, packaging undamaged.</li>
            <li><strong>Products damaged in transit</strong> — visible damage to the jar, lid, or label caused during shipping.</li>
            <li><strong>Wrong product delivered</strong> — you received a different product than what you ordered.</li>
          </ul>
          <p>
            We do <strong>not</strong> accept returns for products that have been opened,
            partially used, or damaged due to improper storage after delivery.
          </p>
        </section>

        <section>
          <h2>3. How to Raise a Request</h2>
          <ol>
            <li>Visit the <strong>Return &amp; Refund</strong> section in your order details (My Orders → select order → Raise Return).</li>
            <li>Select the reason for return.</li>
            <li>Upload clear photographs of the product and packaging (required for all claims).</li>
            <li>Submit — a ticket is generated and our team reviews it within 24–48 hours.</li>
          </ol>
          <p>
            You can also write to us at{" "}
            <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> with your Order ID
            and photos.
          </p>
        </section>

        <section>
          <h2>4. Photo Requirements</h2>
          <p>
            For damaged-in-transit claims, please share:
          </p>
          <ul>
            <li>Photo of the outer packaging / shipping box</li>
            <li>Photo of the damaged product clearly showing the damage</li>
            <li>Photo of the label showing the product name and batch</li>
          </ul>
          <p>Without photos, transit damage claims cannot be processed.</p>
        </section>

        <section>
          <h2>5. Inspection &amp; Approval</h2>
          <p>
            Once your request and photos are reviewed and approved by our team,
            we will arrange a reverse pickup at <strong>no cost to you</strong>.
            PureJar bears all return shipping charges.
          </p>
          <p>
            Physical inspection of the returned product is carried out at our facility.
            Refund or replacement is processed only after inspection confirms eligibility.
          </p>
        </section>

        <section>
          <h2>6. Refund or Replacement</h2>
          <p>
            You may choose either a <strong>full refund</strong> or a{" "}
            <strong>replacement</strong> of the same product, subject to availability.
          </p>
          <p>
            Approved refunds are processed within <strong>5–7 business days</strong> to
            your original payment method. Razorpay refund timelines may vary by bank.
          </p>
        </section>

        <section>
          <h2>7. Non-Returnable Items</h2>
          <ul>
            <li>Products purchased during a sale or at a discounted price (unless damaged in transit)</li>
            <li>Items returned without prior approval</li>
          </ul>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            For any return or refund queries, reach us at{" "}
            <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> or call our
            support line. Please have your Order ID ready.
          </p>
        </section>
      </div>
    </div>
  );
}
